import { useMemo, useState } from 'react';
import { useTranslation } from '@wix/fe-essentials-standalone/i18n';

export type TemplatePageTabID = keyof typeof TEMPLATE_PAGE_TABS;

export const TEMPLATE_PAGE_TABS = {
  about: { id: 'about', key: 'marketplace.template-page.mobile.tabs.about' },
  seller: {
    id: 'seller',
    key: 'marketplace.template-page.mobile.tabs.seller',
  },
  reviews: {
    id: 'reviews',
    key: 'marketplace.template-page.mobile.tabs.reviews',
  },
} as const;

export const TEMPLATE_PAGE_TAB_OPTIONS = Object.entries(TEMPLATE_PAGE_TABS).map(
  ([id, val]) => {
    return { id: val.id, key: val.key };
  },
);

const useMobileTemplatePageTabs = () => {
  const { t } = useTranslation();

  const tabItems = useMemo(
    () =>
      TEMPLATE_PAGE_TAB_OPTIONS.map((tab) => ({
        ...tab,
        title: t(tab.key),
      })),
    [],
  );

  const [activeTabId, setActiveTabId] = useState<TemplatePageTabID>(
    tabItems[0].id,
  );

  return {
    activeTabId,
    setActiveTabId,
    tabItems,
  };
};

export default useMobileTemplatePageTabs;
